'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = undefined;

var _Menu2 = require('./Menu');

var _Menu3 = _interopRequireDefault(_Menu2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/index.js
// module id = 1685
// module chunks = 0